import React from "react";

const fallback = "#94a3b8";

function normalizeCssColor(color: string | undefined): string {
  if (!color || typeof color !== "string") return fallback;
  const t = color.trim();
  if (/^#[0-9A-Fa-f]{6}$/.test(t)) return t.toLowerCase();
  if (/^[0-9A-Fa-f]{6}$/.test(t)) return `#${t.toLowerCase()}`;
  return t.startsWith("#") ? t : fallback;
}

type TagSwatchProps = {
  color?: string;
  className?: string;
  /** Outer tinted tile size */
  size?: "sm" | "md";
};

export default function TagSwatch({ color, className = "", size = "sm" }: TagSwatchProps) {
  const c = normalizeCssColor(color);
  const outer =
    size === "sm" ? "h-[22px] w-[22px] rounded-[6px]" : "h-[26px] w-[26px] rounded-[8px]";
  const inner = size === "sm" ? "h-[10px] w-[10px]" : "h-3 w-3";

  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center ${outer} ${className}`}
      style={{
        backgroundColor: `color-mix(in srgb, ${c} 22%, white)`,
      }}
    >
      <span className={`rounded-full ${inner}`} style={{ backgroundColor: c }} />
    </span>
  );
}
